module.exports = __webpack_public_path__ + "media/Instruction_04.c8192395.mp3";